import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Кръгли чаршафи с ластик памучен сатен 100% памук | Размери по поръчка | GoToBed',
  description:
    'Кръгли чаршафи с ластик от памучен сатен 100% памук. Диаметри 200, 210, 220 см. Височина на матрака 10–50 см. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Кръгли чаршафи с ластик памучен сатен
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Кръгли чаршафи с ластик памучен сатен от 100% памук – голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще намерите кръгли чаршафи с ластик от памучен сатен, които се отличават
          с гладка текстура, мекота и елегантен вид. Предлагаме голям избор от размери, за да
          откриете лесно подходящия вариант за вашия кръгъл матрак. Колекцията включва елегантни
          едноцветни модели и шарени десени с принт. Предлагат се размери с диаметър 200, 210 и 220
          см, както и варианти за матраци с височина от 10 до 50 см.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyKrugliSaten />;
}

function SeoBodyKrugliSaten() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Кръгли чаршафи с ластик от памучен сатен */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Кръгли чаршафи с ластик от памучен сатен
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Кръглите чаршафи с ластик от памучен сатен са отлично решение за кръгли легла и матраци с
        нестандартна форма. При кръгъл матрак стандартните чаршафи често не прилягат добре, свличат
        се или се набират. Затова най-добрият избор е кръгъл чаршаф с ластик, изработен точно по
        размера на матрака.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed изработваме кръгли чаршафи от памучен сатен по индивидуални размери, така че да
        прилягат перфектно към матрака и да осигуряват максимален комфорт по време на сън. При
        поръчка можете да изберете както диаметъра, така и височината на матрака, за да получите
        чаршаф, който пасва идеално.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако търсите и други модели, можете да разгледате:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/kategorii/spalno-belio/krugli-sharshafi-s-lastik/1/6"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          всички кръгли чаршафи с ластик
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/krugli-sharshafi-s-lastik/1/6/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          кръгли чаршафи с ластик ранфорс
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери кръгли чаршафи с ластик от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери кръгли чаршафи с ластик от памучен сатен за кръгъл матрак
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме кръгли чаршафи с ластик от памучен сатен за матраци с диаметър:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['кръгъл чаршаф 200 см', 'кръгъл чаршаф 210 см', 'кръгъл чаршаф 220 см'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Чаршафите могат да бъдат изработени за матраци с височина:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['10–15 см', '16–20 см', '21–25 см', '26–30 см', '31–40 см', '41–50 см'].map(
            (height) => (
              <Typography key={height} variant="body1" sx={{ color: 'text.secondary' }}>
                {height}
              </Typography>
            )
          )}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на ластика по целия ръб, чаршафът обхваща стабилно матрака и остава на
          мястото си през цялата нощ.
        </Typography>

        {/* H2: Какво представлява памучният сатен? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява памучният сатен?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е висококачествен 100% памучен плат, който се отличава с гладка и фина
          повърхност. Благодарение на специалния начин на тъкане материята има лек блясък и създава
          по-луксозно усещане при допир.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основни предимства на памучния сатен:
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>&#10004; 100% естествен памук</li>
          <li>&#10004; гладка и приятна на допир материя</li>
          <li>&#10004; деликатен блясък и по-луксозно усещане</li>
          <li>&#10004; добра дишаемост и комфорт по време на сън</li>
          <li>&#10004; устойчивост при пране и дълготрайна употреба</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако предпочитате спално бельо от тази материя, можете да разгледате:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi/1/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик памучен сатен
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички наши чаршафи от памучен сатен са изработени от платове със сертификат OEKO-TEX
          Standard 100, което гарантира безопасност и високо качество на текстила.
        </Typography>

        {/* H2: Предимства на кръглите чаршафи с ластик от памучен сатен */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на кръглите чаршафи с ластик от памучен сатен
        </Typography>
        <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0, mb: 2 }}>
          <li>&#10004; изработка по индивидуален размер</li>
          <li>&#10004; подходящи за кръгли матраци и кръгли легла</li>
          <li>&#10004; диаметри 200, 210 и 220 см</li>
          <li>&#10004; подходящи за матраци с височина 10–50 см</li>
          <li>&#10004; 100% памучен сатен</li>
          <li>&#10004; OEKO-TEX Standard 100 сертификат на платовете</li>
          <li>&#10004; ластик по целия ръб за стабилно фиксиране</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всеки чаршаф за кръгъл матрак се изработва по поръчка, което гарантира точни размери и
          отлично прилягане.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да завършите комплекта спално бельо, можете да комбинирате чаршафа с:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки памучен сатен
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/kalufki/1/2/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници памучен сатен
          </Typography>
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Кръглите чаршафи от памучен сатен се изработват индивидуално след направена поръчка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на около 4–7 работни дни.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          След изработката поръчката се изпраща с куриер до посочения от вас адрес или до офис на
          куриерската фирма.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за кръгли чаршафи с ластик от памучен сатен
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какво представлява памучният сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучният сатен е 100% памучен плат, който се отличава с гладка, мека повърхност и лек
            блясък. Материята осигурява много приятен допир и по-луксозно усещане в сравнение с
            по-плътните памучни тъкани.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е памучният сатен за чаршафи с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Памучният сатен е отличен избор за чаршафи с ластик, защото е мек, дишащ и много
            комфортен за сън. Освен това материята запазва качествата си и след многократно пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За какви размери кръгли матраци са подходящи чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Предлагаме кръгли чаршафи от памучен сатен за матраци с диаметър 200 см, 210 см и 220
            см, както и за матраци с височина 10–50 см.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свлича ли се чаршафът с ластик от кръгъл матрак?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Не. Ластикът е поставен по целия ръб на чаршафа, което позволява той да прилепне
            стабилно към матрака и да остане на мястото си по време на сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички кръгли чаршафи с ластик от памучен сатен се изработват в България, специално за
            всяка поръчка и според избраните размери на матрака.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
